const routes = {
  exchangeRateCreate: "/currencies/exchange-rates/create",
  exchangeRateList: "/currencies/exchange-rates",
  currencyCreate: "/currencies/create",
  currencyUpdate: "/currencies/:id/update",
  currencyList: "/currencies",
}

export default routes
